import React, { useEffect, useState } from 'react';
import { apiClient } from '../../api/apiClient';

/**
 * Rodapé com logomarca do proprietário da plataforma.
 * Com poweredBy: texto "Powered by" + logo (login da contratante).
 */
export function OwnerBrandFooter({ iconUrl: iconUrlProp, poweredBy = false }) {
  const [fetchedUrl, setFetchedUrl] = useState('');

  useEffect(() => {
    if (iconUrlProp != null && String(iconUrlProp).trim()) return undefined;
    let cancelled = false;
    apiClient
      .getConfig()
      .then((data) => {
        if (!cancelled) {
          setFetchedUrl((data?.platform_owner_icon || '').trim());
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [iconUrlProp]);

  const iconUrl = (iconUrlProp != null ? String(iconUrlProp) : fetchedUrl).trim();
  const hasIcon = iconUrl && (iconUrl.startsWith('http') || iconUrl.startsWith('/'));

  if (!hasIcon && !poweredBy) {
    return null;
  }

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: poweredBy ? '12px 20px 24px' : '16px 20px 28px',
        flexShrink: 0,
        gap: poweredBy ? 6 : 0,
      }}
    >
      {poweredBy && (
        <p
          style={{
            margin: 0,
            fontSize: 11,
            fontWeight: 500,
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color: '#9CA3AF',
          }}
        >
          Powered by
        </p>
      )}
      {hasIcon ? (
        <img
          src={iconUrl}
          alt={poweredBy ? 'FluentSoft' : 'Proprietário da plataforma'}
          style={{
            maxHeight: poweredBy ? 40 : 56,
            maxWidth: poweredBy ? 180 : 200,
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            opacity: poweredBy ? 0.95 : 0.92,
          }}
        />
      ) : (
        poweredBy && (
          <span style={{ fontSize: 13, fontWeight: 600, color: '#6B7280' }}>FluentSoft</span>
        )
      )}
    </div>
  );
}
